module.exports = {"130102001":"建北街道","130102002":"青园街道","130102003":"广安街道","130102004":"育才街道","130102005":"跃进街道","130102007":"河东街道","130102010":"长丰街道","130102011":"谈固街道","130102012":"中山东路街道","130102013":"阜康街道","130102014":"建安街道","130102015":"胜利北街道","130102100":"西兆通镇","130102101":"南村镇","130102102":"高营镇","130102103":"桃园镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130102.json
// module id = 142
// module chunks = 0